lmApp
  .service('AuthenticationService',
  ['$q', '$kookies', '$rootScope', '$timeout', 'ApiService', 'ToastService',
    function ($q, $kookies, $rootScope, $timeout, ApiService, ToastService) {

      /**
       * Get signature from login data
       * @param data
       * @param clientSecret
       * @returns {*}
       */
      function getSignature(data, clientSecret) {
        var signature = Object.keys(data)
          .sort()
          .reduce(function (mem, key) {
            return mem + key + data[key];
          }, '');

        if (clientSecret) signature = signature + clientSecret;

        return CryptoJS.MD5(signature).toString(CryptoJS.enc.Hex);
      }

      var service = {};

      service.CheckAdmin = function () {
        var deferred = $q.defer();

        lh.common.request.get('/token/check/admin', {})
          .then(function (response) {
            deferred.resolve(response.is_admin);
          }, function (reason) {
            reason.url = '/token/check/admin';
            reason.data = 'GET';
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      /**
       * Login service
       * @param username
       * @param clientSecret
       * @returns {*}
       * @constructor
       */
      service.Login = function (username, clientSecret) {

        var deferred = $q.defer();

        var data = {
          email: username.toLowerCase(),
          password: clientSecret
        };

        ApiService.Request('1/auth', 'POST', data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      /**
       * Set Credential to cookies
       * TODO: Change to Session
       * @param username
       * @param self
       * @param token
       * @constructor
       */
      service.SetCredentials = function (username, self, token) {
        var lhSrv = _.find(self.operator.services, {name: "lighthouse"});

        $rootScope.globals = {
          currentUser: {
            project: self.operator.name,
            company_name: self.operator.company_name,
            supervisorToken: token,
            username: self.account.email,
            token: lhSrv ? lhSrv.instance.token : null,
            isSuperuser: self.operator.type === 'mgmt',
            operatorToken: null,
            name: self.operator.name,
            account: self.account,
            operatorId: self.operator.id,
            operatorExtId: self.operator.ext_id,
          }
        };

        $kookies.set('globals', JSON.stringify($rootScope.globals), {path: '/', expires: 7});

        if (lhSrv) {
          if (self.account.type !== 'mgmt') {
            hostname = window.location.host + '/discovery:80';
            protocol = window.location.protocol.replace(':', '');

            lh.common.config.set({authToken: lhSrv.instance.token});
            lh.system.init();
          }
        } else {
          ToastService.Big({
            color: 'amber',
            title: 'Access denied',
            text: 'This service not available for this account',
            icon: 'alert'
          }, 60 * 1000);

          throw {
            result: 0,
            message: 'Service not available'
          };
        }

        return true;
      };

      /**
       * Clear all credential data from cookies
       * @constructor
       */
      service.ClearCredentials = function () {
        $rootScope._self = {};
        $rootScope.globals = {};
        $timeout(function () {
          $kookies.remove('globals', {path: '/'});
        });
      };

      return service;
    }]);
